import React, { Component } from 'react';
import { Toast, ToastBody } from 'react-bootstrap';
import { BrowserView, MobileView } from 'react-device-detect';
import { BrowserRouter as Router } from "react-router-dom";
import Cookies from 'universal-cookie';
import AlertPnl from "../../assets/components/panel/AlertPnl";
import ProgressBullets from '../../assets/components/progressBullets/ProgressBullets';
import TopBar from '../../assets/components/topbar/TopBar';
import logo from '../../images/public/login/logo.png';
import clos from '../../images/public/registeration/clos.png';
import { confirmSMS, sendOTP, userFetch, userLogoutFetch } from '../../libs/fetch';
import tr from '../../libs/tr';
import './ConfirmPhone.css';

const cookies = new Cookies();

// init user from storage
let user;
class ConfirmPhone extends Component {
  constructor(props) {
    super(props);

    this.state = {
      step: '1',
      loadedData: false,
      redirect: false,
      redirectprev: '',
      userRegResponse: '',
      userInfo: '',
      regCode: '',
      regCodeErr: false,
      email: '',
      emailmod: '',
      username: '',
      isModEmail: false,
      isResendCode: false,
      showCodePopupTitle: '',
      showCodePopupMessage: '',
      showCodeConfirmationPopup: false,
      showResendConfirmation: false,
      showSendSMSToast: false,
      toastText: '',
      countdown: 0,
      countdownActive: false,
      resendEnabled: true,
      resendCounter: 0,
      showContactAssistance: false,
    };

    // handler bind
    this.handleChangeCode = this.handleChangeCode.bind(this);
    this.changePhoneNumber = this.changePhoneNumber.bind(this);
    this.sendSMSCode = this.sendSMSCode.bind(this);
    this.resendHandler = this.resendHandler.bind(this);
  }

  componentWillMount() {
  }

  componentDidMount() {
    this.updateResendCounter();
    if (!localStorage.getItem('user')) {
      return this.props.history.push('/');
    }

    user = JSON.parse(localStorage.getItem('user'));
    this.setState({ loadedData: true });

    // Get phone number first, then send SMS code
    this.getPhoneNumber();
  }

  goToTerms = (e) => {
    /**/
    e.preventDefault();

    if (this.canBeSubmitted()) {
      const user = JSON.parse(localStorage.getItem('user'));
      console.log("user data before confirmSMS", user);
      const phoneNumber = user.tel_cell || user.phone;
      try {
        confirmSMS(this, phoneNumber, this.state.regCode, user.email).then((response) => {
          if (response.status === "fail") {
            this.setState({ regCodeErr: true });
          }
          if (response.status === "success") {
            // Update user verification status in localStorage
            const user = JSON.parse(localStorage.getItem('user'));
            if (user) {
              user.phone_verified = true;
              localStorage.setItem('user', JSON.stringify(user));
            }

            // Check if we need to return to a previous page
            const backto = localStorage.getItem('backto');
            if (backto) {
              localStorage.removeItem('backto');
              this.props.history.push({
                pathname: backto,
                state: { fromConfirmPhone: true, phoneVerified: true }
              });
            } else {
              // Check if user is already logged in (phone change flow)
              if (user && user.access_token) {
                // Phone change flow - redirect to user area
                this.props.history.push({
                  pathname: '/userarea',
                  state: { fromConfirmPhone: true, phoneVerified: true }
                });
              } else {
                // Registration flow - continue to terms
                this.props.history.push({
                  pathname: '/terms'
                });
              }
            }
          }
        });
      } catch (error) {
        this.setState({ regCodeErr: true });
      }
    } else {
      console.log('cannot submit form');
    }
  }

  canBeSubmitted = () => {
    var validCode = (this.state.regCode.length > 4) && !this.state.regCodeErr;
    return validCode;
  }

  validateInput = () => {
    return this.validateCode();
  }

  validateCode = (e) => {
    var validCode = (this.state.regCode != '');
    this.setState({ regCodeErr: !validCode });
    return validCode;
  }

  /* handles for each input values changes */
  handleChangeCode = (e) => {
    this.setState({ regCode: e.target.value }, () => {
      this.setState({ regCodeErr: false });
    })
  }

  sendSMSCode = () => {
    this.setState({
      regCode: '',
      showToast: true,
      countdown: 30,
      countdownActive: true
    });

    // Recupera il numero di telefono dall'utente nel localStorage
    // Use phoneNumber from localStorage which includes the country prefix
    const savedPhoneNumber = localStorage.getItem('phoneNumber');
    const user = JSON.parse(localStorage.getItem('user'));
    const phone = savedPhoneNumber || this.state.phone || user.tel_cell || user.phone;

    console.log('📱 Sending SMS to phone:', phone);

    if (!phone) {
      console.error('❌ No phone number available for SMS');
      this.setState({ showSendSMSToast: true, toastText: tr.t("SMSFailedSending") });
      return;
    }

    this.countdownInterval = setInterval(() => {
      this.setState(prevState => {
        if (prevState.countdown > 0) {
          this.setState({ resendEnabled: false });
          return { countdown: prevState.countdown - 1 };
        } else {
          clearInterval(this.countdownInterval);
          this.setState({ resendEnabled: true });
          return { countdownActive: false };
        }
      });
    }, 1000);
    sendOTP(this, phone).then((response) => {
      console.log('📱 sendOTP response:', response);
      if (response.status === 'success') {
        this.setState({ showSendSMSToast: true, toastText: tr.t("SMSSent") });
      } else {
        this.setState({ showSendSMSToast: true, toastText: tr.t("SMSFailedSending") });
      }
    }).catch((e) => {
      console.error('📱 sendOTP error:', e);
      this.setState({ showSendSMSToast: true, toastText: tr.t("SMSFailedSending") });
    });
  }

  updateResendCounter = () => {
    const resendCounter = localStorage.getItem('resendCounter');
    console.log("resendCounter", resendCounter);
    this.setState({ resendCounter: resendCounter }, () => {
      if (this.state.resendCounter > 3) {
        this.setState({ showContactAssistance: true, resendEnabled: false, inScreenPopupMsg: tr.t('ContactUs') });
      }
    });
  }

  resendHandler = (e) => {
    if (!this.state.resendEnabled) {
      return;
    }
    this.updateResendCounter();
    e.preventDefault();
    this.sendSMSCode();
    this.increaseResendCounter();
  }

  // redirect to change-phone route
  goToChangePhone = (e) => {
    // Set backto for return after phone change
    const user = JSON.parse(localStorage.getItem('user'));
    if (user && user.access_token) {
      // User is logged in, should return to userarea after confirmation
      localStorage.setItem('backto', '/userarea');
    }
    this.props.history.push({
      pathname: '/change-phone'
    });
  }

  changePhoneNumber = (e) => {
    e.preventDefault();
    this.goToChangePhone(e);
  }

  handleCloseform = (e) => {
    e.preventDefault();
    return this.setState({ closing: true });

  }

  // LOGOUT! if user decides to  close the terms
  logout = () => {
    try {
      // fill storage w/ user data.
      userLogoutFetch(this).then((response) => {
        localStorage.clear();
        cookies.remove('access_token');
        return this.props.history.push('/');
      });
    } catch (e) {
      console.log(e);
    }
  }

  alertResponse(info) {
    switch (info.type) {
      case "closeButton":
        this.setState({ inScreenPopupShow: false, OKPopupShow: false, closing: false, showCodeConfirmationPopup: false })
        break;
      case "actionButton":
        if (info.option1 === "attention") {
          this.setState({
            inScreenPopupShow: false,
            OKPopupShow: false,
            showCodeConfirmationPopup: false,
            showResendConfirmation: false,
            showContactAssistance: false,
          });
          break;
        }
        if (info.option1 === "cancel") {
          this.setState({ closing: false });
          break;
        }
        if (info.option2 === "exit") {
          this.setState({ closing: false }, () => {
            this.logout();
          });
          break;
        }
        if (info.option1 === "resendCode" || info.option2 === "resendCode") {
          this.setState({ showCodeConfirmationPopup: false, showResendConfirmation: false });
          this.sendSMSCode();
          break;
        }
        if (info.option2 === "attention") {
          this.setState({ showCodeConfirmationPopup: false, showResendConfirmation: false });
          break;
        }
    }
  }

  // Default browser alert function replacement
  handleAlert = (incomingMsg, notitle) => {
    if (notitle) {
      return this.setState({
        OKPopupShow: true,
        inScreenPopupMsg: incomingMsg,
      });
    }
    this.setState({
      inScreenPopupShow: true,
      inScreenPopupMsg: incomingMsg,
    })
  }

  getPhoneNumber = () => {
    let access_token = cookies.get('access_token');
    let params = { access_token: access_token };
    userFetch(this, params).then((response) => {
      if (!response) {
        console.error('Failed to fetch user data');
        return;
      }

      this.setState({ phone: response.tel_cell }, () => {
        // Send SMS code only after phone number is set in state
        console.log('📱 Phone number loaded from server:', response.tel_cell);
        this.sendSMSCode();
      });

      // Update localStorage with the latest phone number from server
      let user = JSON.parse(localStorage.getItem('user'));
      if (user && response.tel_cell) {
        user.tel_cell = response.tel_cell;
        user.phone = response.tel_cell;
        localStorage.setItem('user', JSON.stringify(user));
      }
    }).catch((error) => {
      console.error('Error fetching phone number:', error);
    });

  }

  increaseResendCounter = () => {
    const current = localStorage.getItem('resendCounter');
    if (!current) {
      localStorage.setItem('resendCounter', 1)
    } else {
      localStorage.setItem('resendCounter', current + 1);
    }
  }

  render() {

    //
    const isDisabled = !this.canBeSubmitted();
    const { isResendCode, isModEmail } = this.state

    return (
      <Router>
        <div>
          <Toast style={{ position: 'fixed', top: 0, left: '35%', right: '35%' }} onClose={() => this.setState({ showSendSMSToast: false })} show={this.state.showSendSMSToast} delay={3000} autohide>
            <ToastBody style={{ fontWeight: 'bold' }}>{this.state.toastText}</ToastBody>
          </Toast>
          {
            this.state.loadedData &&
            <div>
              <BrowserView>
                <div className="container-fluid d-lg-none sn_mobile_top_row mt-5">
                  <div className="row flex-nowrap">
                    <div className="col-2 d-flex align-items-center">

                    </div>
                    <div className="col-8 d-flex align-items-center justify-content-center">
                      <img className="sn_mobile_top_row_logo" src={logo} />
                    </div>
                    <div className="col-2 d-flex align-items-center justify-content-end">
                      <div className="sn_exit">
                        <a onClick={this.handleCloseform}>
                          <img src={clos} />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="sn_topbar"><TopBar step={this.state.step} /></div>
                <div className="sn_overlay d-lg-none"></div>
                <div className="sn_confirm">
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-12 col-lg-10 mx-auto">
                        <div className="sn_register__container">
                          <div className="row">
                            <div className="col-3 d-none d-lg-block">
                              <div className="big_arrow_wrap"><div className="big_arrow"></div></div>
                            </div>
                            <div className="col-12 col-lg-9">
                              <div className="row">
                                <div className="col-12 d-flex justify-content-end">
                                  <div className="sn_exit d-none d-lg-block">
                                    <a onClick={this.handleCloseform}>
                                      <img src={clos} />
                                    </a>
                                  </div>
                                </div>
                              </div>
                              <div className="row mb-3">
                                <div className="col-12">
                                  <h3 className="mb-5">{tr.t("ConfirmPhone")}</h3>
                                  <p className="mb-5">
                                    {tr.t("InsertcodeSMS")}
                                    &#160;
                                    {tr.t("YourPhone")}
                                    &#160;
                                    <b>{this.state.phone}</b>
                                  </p>
                                  <input type="tel" name="code" placeholder="12345" className={(this.state.regCodeErr) ? "sn_input err_red" : "sn_input err_no"} maxLength="5" value={this.state.regCode} onChange={this.handleChangeCode} />
                                </div>
                              </div>
                              {(this.state.countdownActive && this.state.resendCounter <= 3) && (
                                <div className="col-12 p-0">
                                  <p className="countdown-timer">{`${tr.t("ResendIn")} ${this.state.countdown} ${tr.t("Seconds")}`}</p>
                                </div>
                              )}
                              <div className="row mb-5">
                                <div className="col-12 col-md-6 mb-3 mb-sm-0">
                                  <a onClick={this.resendHandler}><h5 style={!this.state.resendEnabled ? { opacity: 0.5 } : {}}>{tr.t("ResendSMS")}</h5></a>                                </div>
                                <div className="col-12 col-md-6 text-left text-md-right">
                                  <a onClick={this.changePhoneNumber}><h5>{tr.t("WrongPhone")}</h5></a>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-12 d-flex justify-content-center justify-content-md-end">
                                  <button className="sn_btn" onClick={this.goToTerms} disabled={isDisabled}>{tr.t("Next")}</button>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row d-lg-none mt-5">
                            <div className="col-12">
                              <ProgressBullets step={this.state.step} />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </BrowserView>
              <MobileView>
                <div className="container-fluid d-lg-none sn_mobile_top_row mt-5">
                  <div className="row flex-nowrap">
                    <div className="col-2 d-flex align-items-center"></div>
                    <div className="col-8 d-flex align-items-center justify-content-center">
                      <img className="sn_mobile_top_row_logo" src={logo} />
                    </div>
                    <div className="col-2 d-flex align-items-center justify-content-end">
                      <div className="sn_exit">
                        <a onClick={this.handleCloseform}>
                          <img src={clos} />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="sn_topbar"><TopBar step={this.state.step} /></div>
                <div className="sn_overlay d-lg-none"></div>
                <div className="sn_confirm">
                  <div className="container">
                    <div className="row">
                      <div className="col-12 col-lg-8 mx-auto">
                        <div className="sn_register__container">
                          <div className="row">
                            <div className="col-12 d-flex justify-content-end">
                              <div className="sn_exit d-none d-lg-block">
                                <a onClick={this.handleCloseform}>
                                  <img src={clos} />
                                </a>
                              </div>
                            </div>
                          </div>
                          <h3>{tr.t("ConfirmPhone")}</h3>
                          <p>
                            {tr.t("InsertCodeSMS")}
                            &#160;
                            {tr.t("YourPhone")}
                            &#160;
                            <b>{this.state.phone}</b>
                          </p>
                          <div className="sn_input mb-2">
                            <input type="tel" name="code" placeholder="12345" className={(this.state.regCodeErr) ? "txlf1" : "txlf"} maxLength="5" value={this.state.regCode} onChange={this.handleChangeCode} />
                          </div>
                          {(this.state.countdownActive && this.state.resendCounter <= 3) && (
                            <div className="col-12 p-0">
                              <p className="countdown-timer">{`${tr.t("ResendIn")} ${this.state.countdown} ${tr.t("Seconds")}`}</p>
                            </div>
                          )}
                          <div className="d-flex justify-content-between mb-3">
                            <a onClick={this.resendHandler}><h5 style={!this.state.resendEnabled ? { opacity: 0.5 } : {}}>{tr.t("ResendSMS")}</h5></a>
                            <a onClick={this.changePhoneNumber}><h5>{tr.t("WrongPhone")}</h5></a>
                          </div>
                          <div className="row">
                            <div className="col-12 d-flex justify-content-end">
                              <button className="sn_btn" onClick={this.goToTerms} disabled={isDisabled}>{tr.t("Next")}</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </MobileView>
            </div>
          }
          {
            this.state.inScreenPopupShow ?
              <div className="containerModal">
                {
                  this.state.inScreenPopupShow ?
                    <AlertPnl textbar1={tr.t("Attention")} secondbar={true} textbar2={this.state.inScreenPopupMsg} singlebtn={true} textbtn1={tr.t("Ok")} sizebtn={"medium"} option1={"attention"} callback={this.alertResponse.bind(this)} /> : null
                }
              </div> : null
          }
          {
            this.state.showContactAssistance ?
              <div className="containerModal">
                <AlertPnl textbar1={this.state.inScreenPopupMsg} secondbar={true} thirdbar={true} textbar2={tr.t("Assisemail")} textbar3={tr.t('Telnumber')} singlebtn={true} textbtn1={tr.t("Ok")} sizebtn={"medium"} option1={"attention"} callback={this.alertResponse.bind(this)} />
              </div> : null
          }
          {
            this.state.OKPopupShow ?
              <div className="containerModal">
                {
                  this.state.OKPopupShow ?
                    <AlertPnl textbar1={" "} secondbar={true} textbar2={this.state.inScreenPopupMsg} singlebtn={true} textbtn1={tr.t("Ok")} sizebtn={"medium"} option1={"attention"} callback={this.alertResponse.bind(this)} /> : null
                }
              </div> : null
          }
          {
            this.state.showCodeConfirmationPopup ?
              <div className="containerModal">
                <AlertPnl textbar1={tr.t("Attention")} secondbar={true} textbar2={tr.t("ErrorSendingSMS")} doublebtnhor={true} singlebtn={false} textbtn1={tr.t('ResendCode')} textbtn2={tr.t("Ok")} sizebtn={"medium"} option1={"resendCode"} option2={"attention"} callback={this.alertResponse.bind(this)} />
              </div> : null
          }
          {
            this.state.closing ?
              <div className="containerModal">
                {
                  this.state.closing ?
                    <AlertPnl textbar1={tr.t("Attention")} secondbar={true} textbar2={tr.t("cantcloseEmailForm")} doublebtnhor={true} textbtn1={tr.t("Cancel")} textbtn2={tr.t("Ok")} option1={"cancel"} option2={"exit"} callback={this.alertResponse.bind(this)} /> : null
                }
              </div> : null
          }
        </div>
      </Router>
    );
  }
}

export default ConfirmPhone;


// WEBPACK FOOTER //
// ./src/screens/ConfirmPhone/ConfirmPhone.js